<template>
  <v-data-table
    dense
    no-data-text="Nothing to see here..."
    no-results-text="You filtered a little too hard there bud..."
    :headers="measurementHeaders"
    :items="measurements"
    :loading="loading"
  >
    <template v-slot:item.action="{ item }" v-if="isDetailed">
      <QualityCoatedMeasurementForm
        :is-edit="true"
        :batchid="batchid"
        :is-duplicate="false"
        :instance="item"
      />
      <QualityCoatedMeasurementForm
        :is-edit="false"
        :batchid="batchid"
        :is-duplicate="true"
      />
      <QualityMeasurementDeleteForm
        :instance="item"
      />
    </template>
  </v-data-table>
</template>

<script>
import QualityCoatedMeasurementForm from "./QualityCoatedMeasurementForm";
import QualityMeasurementDeleteForm from "./QualityMeasurementDeleteForm";
export default {
  name: "QualityCoatedMeasurementTable",
  components: {
    QualityCoatedMeasurementForm,
    QualityMeasurementDeleteForm
  },
  props: {
    batchid: {
      type: Number,
      required: false
    },
    isDetailed: {
      type: Boolean,
      required: true,
      default: false
    },
    measurements: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      measurementHeaders: [
        { text: "Batch", sortable: true, value: "batch.forgeID" },
        { text: "ICP", sortable: true, value: "icp" },
        { text: "Analyte", sortable: true, value: "analyte" },
        { text: "Reagent", sortable: true, value: "reagent" },
        { text: "Moisture", sortable: true, value: "ppm_water" },
        { text: "Surface Area", sortable: true, value: "bet" },
        { text: "Density", sortable: true, value: "density" },
        { text: "Run", sortable: true, value: "run" },
        { text: "Notes", sortable: true, value: "note" },
        { text: "Actions", value: "action", align: "center" }
      ]
    };
  }
};
</script>

